var _style, _path, _path2, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeftWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "left-white_svg__Layer_1",
    x: 0,
    y: 0,
    viewBox: "0 0 984.8 957.7",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null)), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M856.7 511.4H56.2c-17.9 0-32.5-14.6-32.5-32.5s14.6-32.5 32.5-32.5h800.6c17.9 0 32.5 14.6 32.5 32.5s-14.6 32.5-32.6 32.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M478.9 957.7c-8.3 0-16.6-3.2-23-9.5L9.5 501.8c-12.7-12.7-12.7-33.3 0-46L455.9 9.5c12.7-12.7 33.3-12.7 46 0 12.7 12.7 12.7 33.3 0 46L78.5 478.9l423.4 423.4c12.7 12.7 12.7 33.3 0 46-6.4 6.3-14.7 9.4-23 9.4z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 952.3,
    cy: 478.9,
    r: 32.5,
    fill: "#FFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftWhite);
export default ForwardRef;